import { config } from '@/config.ts';
import i18n from '@/i18n';

declare global {
	interface Window {
		dataLayer: any[];
	}
}

export interface GTMEvent {
	event: string;
	[key: string]: any;
}

export interface PageViewData {
	event: string;
	page_location: string;
	brand_name: string;
	brand_environment: string;
	user_locale: string;
}

const FALLBACK_LOCALE = 'en';

const isGtmEnabled = (): boolean => config.ENV === 'production' && Boolean(config.GTM_ID);

export const gtmTracker = {
	init(): void {
		if (!isGtmEnabled()) return;
		if (globalThis.window !== undefined && !globalThis.window.dataLayer) {
			globalThis.window.dataLayer = [];
		}
	},

	trackEvent(eventName: string, eventData?: Record<string, any>): void {
		if (!isGtmEnabled()) return;
		if (globalThis.window === undefined) return;

		this.init();

		const event: GTMEvent = {
			event: eventName,
			brand_name: config.BRAND ?? 'default',
			brand_environment: config.ENV ?? 'development',
			user_locale: i18n.language || FALLBACK_LOCALE,
			...eventData
		};

		globalThis.window.dataLayer.push(event);

		if (import.meta.env.DEV) {
			console.log('GTM Event:', event);
		}
	},

	trackPageView(): void {
		if (!isGtmEnabled()) return;
		if (globalThis.window === undefined) return;

		this.init();

		const pageViewData: PageViewData = {
			event: 'page_view',
			brand_name: config.BRAND ?? 'default',
			brand_environment: config.ENV ?? 'development',
			user_locale: i18n.language || FALLBACK_LOCALE,
			page_location: globalThis.window.location.href
		};

		globalThis.window.dataLayer.push(pageViewData);

		if (import.meta.env.DEV) {
			console.log('GTM Page View:', pageViewData);
		}
	}
};

export default gtmTracker;
